import { useMemo } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { WaterfallFundSummaryRowConfig } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/FundSummaryRowConfig/WaterfallFundSummaryRowConfig';
import {
  WATERFALL_FUND_SUMMARY_COLUMNS
} from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/useFundSummarySheetConfig/UseWaterfallFundSummarySheetConfig.constants';
import { UseWaterfallFundSummarySheetConfigProps } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/useFundSummarySheetConfig/useWaterfallFundSummarySheetConfig.props';
import { waterfallFundSummaryParser } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/WaterfallFundSummaryParser/WaterfallFundSummaryParser';

export const useWaterfallFundSummarySheetConfig = ({ captable, fundList, childrenCompanies, calculatedEquityValue, fundIrrMap }: UseWaterfallFundSummarySheetConfigProps) => {
  const rowConfig = useMemo(() => {
    if (!captable || !calculatedEquityValue) {
      return [];
    }
    return WaterfallFundSummaryRowConfig({ captable, fundIrrMap });
  }, [captable, calculatedEquityValue, fundIrrMap]);

  const tableData = useMemo(
    () => {
      if (captable) {
        return ({
          fundList,
          childrenCompanies,
          captable
        });
      }
    },
    [fundList, childrenCompanies, captable]
  );

  const sheetConfig = useMemo(() => {
    if (rowConfig) {
      return new SpreadsheetConfig({
        name: 'waterfallFundSummary',
        showTitlesColumn: false,
        reverseParser: undefined,
        tableData,
        columns: WATERFALL_FUND_SUMMARY_COLUMNS,
        rowConfig,
        parser: waterfallFundSummaryParser,
      });
    }
    return null;
  }, [rowConfig, tableData]);

  return {
    sheetConfig,
  };
}